import { render, staticRenderFns } from "./Zan.vue?vue&type=template&id=de13607c&scoped=true&"
import script from "./Zan.vue?vue&type=script&lang=js&"
export * from "./Zan.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/zan.css?vue&type=style&index=0&id=de13607c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de13607c",
  null
  
)

export default component.exports